import React, { FC, useState, ChangeEvent } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  MenuItem,
  Select,
} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import AppsIcon from '@material-ui/icons/Apps';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useStyles, BootstrapInput } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import TabPanel from 'components/TabPanel';
// interface ReportData {
//     totalAuthentications: number;
//     uniqueUsers: number;
//     connectedApps: number;

// }

const OIDC: FC = () => {
  const classes = useStyles();
  const [period, setPeriod] = useState('year');
  const [activeTab, setActiveTab] = useState('one');

  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setActiveTab(newValue);
  };
  const {
    logsTableStore: { getOidcReports, viewUser, viewEndUser },
    userStore: { user },
    notificationStore: { openNotification },
  } = useStore();

  const getClickedUser = useMutation(
    'viewUserOidc',
    (ClientId: number) => (user?.permission !== 'EndUser' ? viewUser(ClientId) : viewEndUser(ClientId)),
    {
      onSuccess: (res) => {
        let url;
        if (res?.data?.message === 'End User Group and Department') {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        localStorage.setItem('ClickedUser', JSON.stringify(res.data.user));
        if (res?.data?.message === 'User found') {
          url = `${handleCompanyUrl('/user/view')}`;
          window.open(url, '_blank');
        } else {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        window.open(url, '_blank');
      },
      onError: (error: any) => {
        openNotification('error', error.data?.message || error.message || 'User not found');
      },
    }
  );

  const getOidcReportsReq = useQuery(
    ['getOidcReportsReq', period],
    () => getOidcReports(period, '', ''),
    {
      onError: (e: any) => {
        openNotification('error', `Can't Get OIDC Reports`);
      },
    }
  );

  useAppPreloader(getOidcReportsReq.isFetching);
  const logData = getOidcReportsReq.data?.data?.logs?.data || [];

  return (
    <>
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <div className={classes.flex}>
          <Select
            value={period}
            onChange={(e) => setPeriod(e.target.value as string)}
            displayEmpty
            input={<BootstrapInput />}
          >
            <MenuItem value='week'>Week</MenuItem>
            <MenuItem value='month'>Month</MenuItem>
            <MenuItem value='year'>Year</MenuItem>
          </Select>
        </div>
      </Grid>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className={classes.tabs}
        TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
        variant='standard'
      >
        <Tab value='one' label='Authenticate' {...a11yProps('one')} className={classes.label} />
        <Tab value='two' label='Unique Users' {...a11yProps('two')} className={classes.label} />
        <Tab value='three' label='Connected Apps' {...a11yProps('three')} className={classes.label} />
      </Tabs>
      <div className={classes.tabBox}>
        <TabPanel value={activeTab} index='one'>
          <Grid container spacing={3}>
            {getOidcReportsReq.data?.data?.authentications_by_period?.data?.length > 0 ? (
              getOidcReportsReq.data?.data?.authentications_by_period?.data?.map((item: any, index: number) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={classes.statsCard}>
                    <CardContent>
                      <AssessmentIcon className={classes.statsIcon} style={{ color: '#1976d2' }} />
                      <Typography className={classes.statsValue}>
                        {item.authentication_count.toLocaleString()}
                      </Typography>
                      <Typography className={classes.statsLabel}>Authentications - {item.period}</Typography>
                      <Typography variant='body2' style={{ marginTop: 8, color: '#666' }}>
                        Period: {period} | {item.period}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Card className={classes.statsCard}>
                  <CardContent>
                    <Typography align='center'>No authentication data available</Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>

          <Paper className={classes.tableContainer} style={{ marginTop: 24 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Date And Time</strong></TableCell>
                    <TableCell><strong>Description</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logData.length > 0 ? (
                    logData.map((item: any, index: number) => {
                      const d = item.created_at ? new Date(item.created_at) : null;
                      const formattedDate = d && !isNaN(d.getTime())
                        ? d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) +
                          ' · ' +
                          d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
                        : item.created_at || '-';

                      const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
                      const parts = (item.description || '').split(emailRegex);
                      const description = parts.map((part: string, i: number) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(part)
                          ? <span key={i} style={{ color: '#1976d2', fontWeight: 500, cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); getClickedUser.mutate(item.user_id); }}>{part}</span>
                          : <span key={i}>{part}</span>
                      );

                      return (
                        <TableRow key={index}>
                          <TableCell component='th' scope='row' style={{ whiteSpace: 'nowrap' }}>
                            {formattedDate}
                          </TableCell>
                          <TableCell>{description}</TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2} align='center'>No log data available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>

        <TabPanel value={activeTab} index='two'>
          <Grid container spacing={3}>
            {getOidcReportsReq.data?.data?.unique_users_by_period?.data?.length > 0 ? (
              getOidcReportsReq.data?.data?.unique_users_by_period?.data?.map((item: any, index: number) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={classes.statsCard}>
                    <CardContent>
                      <PeopleIcon className={classes.statsIcon} style={{ color: '#4caf50' }} />
                      <Typography className={classes.statsValue}>{item.unique_user_count.toLocaleString()}</Typography>
                      <Typography className={classes.statsLabel}>Unique Users - {item.period}</Typography>
                      <Typography variant='body2' style={{ marginTop: 8, color: '#666' }}>
                        Period: {period} | {item.period}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Card className={classes.statsCard}>
                  <CardContent>
                    <Typography align='center'>No unique users data available</Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index='three'>
          <Paper className={classes.tableContainer}>
            {/* <Typography variant="h6" style={{ padding: 16, borderBottom: '1px solid #e0e0e0' }}>
                            Connected Apps
                        </Typography> */}
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong> Connected Apps</strong>
                    </TableCell>
                    <TableCell align='center'>
                      <strong>Number of Unique Users</strong>
                    </TableCell>
                    <TableCell align='center'>
                      <strong>Number of Logins</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getOidcReportsReq.data?.data?.connected_apps?.data?.length > 0 ? (
                    getOidcReportsReq.data?.data?.connected_apps?.data?.map((app: any) => (
                      <TableRow key={app.app_name}>
                        <TableCell component='th' scope='row'>
                          {app.app_name}
                        </TableCell>
                        <TableCell align='center'>{app.unique_user_count}</TableCell>
                        <TableCell align='center'>{app.login_count}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align='center'>
                        No connected apps data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>
      </div>
    </>
  );
};

export default OIDC;
